import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import displayNames from '../displayNames';
import TextFormattingToggleButton from '../textFormattingToggleButton';
import TextFormattingButtonWithDropDown from '../textFormattingButtonWithDropDown';
import bold from '../icons/textBold.svg.js';
import italic from '../icons/textItalic.svg.js';
import underline from '../icons/textUnderline.svg.js';
import link from '../icons/textLink.svg.js';
import unlink from '../icons/textUnlink.svg.js';
import color from '../textFormattingColor';
import highlight from '../textFormattingHighlight';
var symbols = {
  bold: bold,
  italic: italic,
  underline: underline,
  link: link,
  unlink: unlink,
  color: color,
  highlight: highlight
};

var buildTextFormattingComp = function buildTextFormattingComp(name, SymbolComponent) {
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var CompClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : TextFormattingToggleButton;

  var Comp = function Comp(props) {
    return /*#__PURE__*/React.createElement(CompClass, _extends({}, props, {
      name: name
    }), /*#__PURE__*/React.createElement(SymbolComponent, props));
  };

  Comp.displayName = name;
  Comp.defaultProps = defaultProps;
  return /*#__PURE__*/React.createElement(Comp, defaultProps);
};

var Bold = function Bold(_ref) {
  var dataHook = _ref.dataHook,
      value = _ref.value,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      tooltipContent = _ref.tooltipContent;
  return /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHook
  }, buildTextFormattingComp(displayNames.TEXT_BOLD_BUTTON, symbols.bold, {
    value: value,
    onChange: onChange,
    disabled: disabled,
    tooltipContent: tooltipContent
  }));
};

var Italic = function Italic(_ref2) {
  var dataHook = _ref2.dataHook,
      value = _ref2.value,
      onChange = _ref2.onChange,
      disabled = _ref2.disabled,
      tooltipContent = _ref2.tooltipContent;
  return /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHook
  }, buildTextFormattingComp(displayNames.TEXT_ITALIC_BUTTON, symbols.italic, {
    value: value,
    onChange: onChange,
    disabled: disabled,
    tooltipContent: tooltipContent
  }));
};

var Underline = function Underline(_ref3) {
  var dataHook = _ref3.dataHook,
      value = _ref3.value,
      onChange = _ref3.onChange,
      disabled = _ref3.disabled,
      tooltipContent = _ref3.tooltipContent;
  return /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHook
  }, buildTextFormattingComp(displayNames.TEXT_UNDERLINE_BUTTON, symbols.underline, {
    value: value,
    onChange: onChange,
    disabled: disabled,
    tooltipContent: tooltipContent
  }));
};

var Link = function Link(_ref4) {
  var dataHook = _ref4.dataHook,
      value = _ref4.value,
      onChange = _ref4.onChange,
      disabled = _ref4.disabled,
      tooltipContent = _ref4.tooltipContent;
  return /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHook
  }, buildTextFormattingComp(displayNames.TEXT_LINK_BUTTON, symbols.link, {
    hasBackgroundWhenSelected: true,
    options: [{
      value: false,
      content: /*#__PURE__*/React.createElement(symbols.unlink, null),
      key: 'false'
    }, {
      value: true,
      content: /*#__PURE__*/React.createElement(symbols.link, null),
      key: 'true'
    }],
    value: value,
    onChange: onChange,
    disabled: disabled,
    tooltipContent: tooltipContent
  }, TextFormattingButtonWithDropDown));
};

var Color = function Color(_ref5) {
  var dataHook = _ref5.dataHook,
      value = _ref5.value,
      onChange = _ref5.onChange,
      disabled = _ref5.disabled,
      tooltipContent = _ref5.tooltipContent;
  return /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHook
  }, buildTextFormattingComp(displayNames.TEXT_COLOR_BUTTON, symbols.color, {
    value: value,
    onChange: onChange,
    disabled: disabled,
    tooltipContent: tooltipContent
  }));
};

var Highlight = function Highlight(_ref6) {
  var dataHook = _ref6.dataHook,
      value = _ref6.value,
      onChange = _ref6.onChange,
      disabled = _ref6.disabled,
      tooltipContent = _ref6.tooltipContent;
  return /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHook
  }, buildTextFormattingComp(displayNames.TEXT_HIGHLIGHT_BUTTON, symbols.highlight, {
    value: value,
    onChange: onChange,
    disabled: disabled,
    tooltipContent: tooltipContent
  }));
};

export default {
  bold: Bold,
  italic: Italic,
  underline: Underline,
  link: Link,
  color: Color,
  highlight: Highlight
};